import React, { useMemo, useState } from 'react';
import TableHead from './TableHead';
import TableData from './TableData';
import TableFooter from './TableFooter';
import TableSearch from './TableSearch';
import style from './Table.module.scss';

const Table = ({
  columns,
  data,
  options,
  emptyContent = '-',
  pagination,
  changePage,
  defaultMessage = '',
  showNext = false,
}) => {

  const [selected, setSelected] = useState({});

  const selectedLen = useMemo(() => {
    let length = 0;
    if (options?.selection?.enable) {
      length = Object.entries(selected).length;
      length &&
        options?.selection?.notselect?.forEach((id) => {
          const found = data.find((d) => d.id === id);
          if (found) {
            length++;
          }
        });
    }

    return length;
  }, [options?.selection, selected, data]);

  const hSelection = (e, d) => {
    const nSel = { ...selected };

    if (nSel[d.id]) {
      delete nSel[d.id];
    } else {
      nSel[d.id] = d;
    }

    setSelected(nSel);
    options?.selection?.onChange(Object.entries(nSel).map(([, item]) => item));
  };

  const hSelectionAll = () => {
    if (selectedLen !== data.length) {
      const aSel = data.reduce((obj, arr) => {
        if (!options?.selection?.notselect?.includes(arr.id)) {
          obj[arr.id] = arr;
        }
        return obj;
      }, {});
      setSelected(aSel);
      options?.selection?.onChange(Object.entries(aSel).map(([, item]) => item));
    } else {
      setSelected({});
      options?.selection?.onChange([]);
    }
  };

  return (
    <>
      <div className={style['wrapper']}>
        <div className={style['table-container']}>
          <table className={style['t_table']}>
            <TableHead data={data} columns={columns} options={options} hSelectionAll={hSelectionAll} selectedLen={selectedLen} />

            <tbody className={style['t_body']}>
              {options?.search && <TableSearch columns={columns} options={options} />}

              <TableData columns={columns} data={data} emptyContent={emptyContent} selected={selected} options={options} hSelection={hSelection} />
            </tbody>
          </table>
          {!data?.length ? (
            <div className={style['emptyContent']}>{defaultMessage || 'No records to display'}</div>
          ) : null}
        </div>
      </div>
      {pagination && data.length > 0 && (
        <TableFooter pagination={pagination} changePage={changePage} dataLength={data?.length} showNext={showNext} />
      )}
    </>
  );
};

export default Table;
